"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTask = exports.getRunningTasks = exports.closeChannel = exports.setChannel = exports.removeChannel = exports.getChannels = exports.getChannel = void 0;

var _object = require("lodash/object");

var channels = {};
var tasks = [];

var getChannel = function getChannel(id) {
  return channels[id];
};

exports.getChannel = getChannel;

var getChannels = function getChannels() {
  return channels;
};

exports.getChannels = getChannels;

var removeChannel = function removeChannel(id) {
  var channel = channels[id];
  channels = (0, _object.omit)(channels, id);
  return channel;
};

exports.removeChannel = removeChannel;

var setChannel = function setChannel(id, channel, buffer) {
  channels[id] = {
    channel: channel,
    buffer: buffer
  };
};

exports.setChannel = setChannel;

var closeChannel = function closeChannel(productID) {
  return function () {
    var _removeChannel = removeChannel(productID),
        channel = _removeChannel.channel;

    channel.close();
  };
};

exports.closeChannel = closeChannel;

var getRunningTasks = function getRunningTasks() {
  return tasks.filter(function (task) {
    return task.isRunning();
  });
};

exports.getRunningTasks = getRunningTasks;

var addTask = function addTask(task) {
  return tasks.push(task);
};

exports.addTask = addTask;